import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import { Box } from "@mui/material";

function EditDatePicker({
  date,
  setDate,
  maxDate,
  minDate,
}: {
  label: string;
  date: Date | Date[] | null | string;
  setDate: (date: Date | string | null) => void;
  maxDate?: Date;
  minDate?: Date;
}) {
  const handleDateChange = (date: Date | null) => {
    setDate(date);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Calendar
          onChange={(date) => handleDateChange(date as Date)}
          value={date as Date}
          maxDate={maxDate}
          minDate={minDate}
        />
      </Box>
    </Box>
  );
}

export default EditDatePicker;
